'use client';

import { FC, useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';

import { productDetailPayloadToBaseCarData } from 'src/data/ProductApi/ProductDetailPayloadToBaseCarData';
import { addSkuToRecentlyViewed } from 'src/general/helpers/recentlyViewedCookie';
import { cartStore } from 'src/stores/cartStore';
import { pdpStore } from 'src/stores/pdpStore';
import { ProductDetailsPayload } from 'src/types/ProductDetail.type';
import { pushToDataLayer } from 'src/utils/pushToDataLayer';
import { carDataToDataLayerItem } from 'src/utils/pushToDataLayerProductCard';

type Props = {
  productDetails: ProductDetailsPayload;
};

export const PdpManager: FC<Props> = ({ productDetails }) => {
  const [displayedCarSwitch, setDisplayedCarSwitch] = useState<boolean>(false);
  const { setCurrentModal } = pdpStore(
    ({ setCurrentModal }) => ({
      setCurrentModal,
    }),
    shallow,
  );
  const { carLoading, carData, cartExpired } = cartStore(
    (state) => ({
      carLoading: state.carLoading,
      carData: state.carData,
      cartExpired: state.cartExpired,
    }),
    shallow,
  );

  useEffect(() => {
    sendGtmEvents(productDetails);
    addSkuToRecentlyViewed(productDetails.sku);
  }, [productDetails]);

  useEffect(() => {
    let showCartCarSwitch = false;
    if (globalThis.window !== undefined) {
      showCartCarSwitch = new URLSearchParams(window.location.search).get('action') === 'switchCart';
    }

    const result = showCartCarSwitch && !carLoading && !!carData && !cartExpired;
    if (result && !displayedCarSwitch) {
      setCurrentModal({ name: 'carSwitch' });
      setDisplayedCarSwitch(true);
    }
  }, [carLoading, carData, cartExpired, displayedCarSwitch]);

  return null;
};

const sendGtmEvents = (productDetails: ProductDetailsPayload) => {
  pushToDataLayer({ ecommerce: null });
  pushToDataLayer({
    event: 'view_item',
    ecommerce: {
      items: [carDataToDataLayerItem(productDetailPayloadToBaseCarData(productDetails))],
    },
  });
};
